import { render } from "./copy-right.vue?vue&type=template&id=3df364b2"
import script from "./copy-right.vue?vue&type=script&lang=js"
export * from "./copy-right.vue?vue&type=script&lang=js"

import "./copy-right.vue?vue&type=style&index=0&id=3df364b2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/copyRight/copy-right.vue'],['render',render],['__file',"copy-right.vue"]])

export default __exports__